export const QUERY_KEY_SETTINGS = 'settings';

export const SETTINGS_PERIOD = 'period';
export const SETTINGS_WORKPLACES = 'workplaces';
export const SETTINGS_FILTERS = 'filters';

const types = [
  {type: SETTINGS_PERIOD, label: 'Zeitraum'},
  {type: SETTINGS_WORKPLACES, label: 'Linien'},
  {type: SETTINGS_FILTERS, label: 'Filter'}
];

export default types;
